// extracted by mini-css-extract-plugin
export default {"externalCheckout":"styles_externalCheckout__E50M4"};